import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface DiamondProps extends HTMLAttributes<HTMLSpanElement> {
  color?: string;
}

export function Diamond({ color, className, ...rest }: DiamondProps) {
  return (
    <span
      className={cn('inline-block h-1.5 w-1.5 flex-none rotate-45', className)}
      aria-hidden="true"
      style={{ background: color ?? 'var(--ollio-gold)' }}
      {...rest}
    />
  );
}
